import React, { useState, useEffect, useRef } from 'react';
import { Modal, ModalHeader, ModalBody, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import ArchivoService from '../../axios_services/archivos.service';
import { Paperclip } from 'lucide-react';

const ModalGestionServicioSistemas = ({
    isOpen,
    registro,
    onSave,
    onClose,
    onModalClosed,
    usuarioId,
    perfilId,
    areaId,
    estadosGestion = [],
    prioridadGestion = [],
    usuariosCatalog = [],
    perfilesCatalog = []
}) => {
    const getLocalDate = () => {
        const now = new Date();
        return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    };

    const getInitialState = () => ({
        usuario_id_solicitante: usuarioId,
        area_id: areaId,
        fecha_registro: getLocalDate(),
        requerimiento: '',
        encargado_id: '',
        comentario: '',
        horas_estimadas: '',
        prioridad_id: '',
        fecha_inicio: '',
        fecha_entrega: '',
        estado: 1
    });

    const [formData, setFormData] = useState(getInitialState());
    const [documentoServicio, setDocumentoServicio] = useState(null);
    const fileInputRef = useRef(null);

    useEffect(() => {
        if (isOpen) {
            if (registro) {
                setFormData({
                    gestion_servicio_id: registro.gestion_servicio_id,
                    usuario_id_solicitante: registro.usuario_id_solicitante,
                    area_id: registro.area_id,
                    fecha_registro: registro.fecha_registro?.split('T')[0] || '',
                    requerimiento: registro.requerimiento || '',
                    encargado_id: registro.encargado_id || '',
                    comentario: registro.comentario || '',
                    horas_estimadas: registro.horas_estimadas != null ? registro.horas_estimadas : '',
                    prioridad_id: registro.prioridad_id || '',
                    fecha_inicio: registro.fecha_inicio?.split('T')[0] || '',
                    fecha_entrega: registro.fecha_entrega?.split('T')[0] || '',
                    estado: registro.estado
                });
            } else {
                setFormData(getInitialState());
                setDocumentoServicio(null);
                if (fileInputRef.current) fileInputRef.current.value = "";
            }
        }
    }, [registro, isOpen, usuarioId, areaId]);

    const handleChange = (e) => {
        const { name, value, type, files } = e.target;
        if (type === 'file') {
            setDocumentoServicio(files[0]);
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleSubmit = async () => {
        if (!formData.requerimiento) {
            alert('Por favor, ingrese el requerimiento.');
            return;
        }

        const dataToSave = {
            ...formData,
            usuario_id_solicitante: parseInt(formData.usuario_id_solicitante),
            area_id: parseInt(formData.area_id),
            encargado_id: formData.encargado_id ? parseInt(formData.encargado_id) : null,
            horas_estimadas: formData.horas_estimadas !== '' && formData.horas_estimadas != null ? parseFloat(formData.horas_estimadas) : null,
            prioridad_id: formData.prioridad_id ? parseInt(formData.prioridad_id) : null,
            estado: parseInt(formData.estado)
        };

        try {
            const savedRegistro = await onSave(dataToSave);
            const targetId = formData.gestion_servicio_id || savedRegistro?.data?.gestion_servicio_id || savedRegistro?.gestion_servicio_id;

            if (documentoServicio && targetId) {
                await ArchivoService.guardarDocumentoServicioSistemas(documentoServicio, targetId, usuarioId);
            }

            onClose(true);
        } catch (error) {
            console.error("Error al guardar:", error);
        }
    };

    const isAdmin = Number(perfilId) === 8;
    const isNew = !registro;
    const canRegister = [8, 5, 1, 6, 9, 11, 12, 15, 21, 22, 24, 25, 26].includes(Number(perfilId));
    const perfilesSistemas = perfilesCatalog.filter(p => Number(p.area_id) === 3).map(p => Number(p.perfil_id));
    const usuariosSistemas = usuariosCatalog.filter(u => perfilesSistemas.includes(Number(u.perfil_id)));

    return (
        <Modal isOpen={isOpen} onClosed={onModalClosed} className="custom-modal" backdrop="static" size="lg">
            <ModalHeader className="modal-header">
                <div className="titulo">
                    <h1>{registro ? 'EDITAR GESTIÓN DE SERVICIO' : 'NUEVA GESTIÓN DE SERVICIO'}</h1>
                    <Button className="close-btn" onClick={() => onClose()}>X</Button>
                </div>
            </ModalHeader>
            <div className="modal-body-footer">
                <ModalBody className="modal-body">
                    <Form className="fila" onSubmit={(e) => e.preventDefault()}>

                        {/* Requerimiento */}
                        <FormGroup>
                            <Label>Requerimiento: <span style={{ color: 'red' }}>*</span></Label>
                            <Input
                                className="form-control"
                                type="textarea"
                                name="requerimiento"
                                value={formData.requerimiento}
                                onChange={handleChange}
                                placeholder="Ingrese su requerimiento."
                                disabled={!isNew && !isAdmin && Number(formData.estado) !== 1}
                                rows={8}
                                maxLength={255}
                            />
                            <span className="text-muted" style={{ fontSize: "12px", float: "right" }}>{(formData.requerimiento?.length || 0)} / 255</span>
                            <div style={{ clear: 'both' }}></div>
                        </FormGroup>

                        <FormGroup style={{ gridColumn: '1 / -1' }}>
                            <Label>Archivo referencia (Opcional):</Label>
                            <div className="custom-file-upload border p-2" style={{ display: 'flex', alignItems: 'center', backgroundColor: '#ffffff', borderRadius: '30px' }}>
                                <Button
                                    className="button-custom"
                                    onClick={() => fileInputRef.current && fileInputRef.current.click()}
                                    style={{ display: 'flex', alignItems: 'center', gap: '5px', marginRight: '15px', fontSize: '11px', padding: '4px 10px', borderRadius: '8px' }}
                                    type="button"
                                >
                                    <Paperclip size={14} />
                                    {documentoServicio ? 'Cambiar archivo' : 'Adjuntar archivo'}
                                </Button>
                                <span className="text-muted" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', flex: 1, fontSize: '11px' }}>
                                    {documentoServicio ? documentoServicio.name : 'Ningún archivo seleccionado'}
                                </span>
                                <Input
                                    type="file"
                                    name="documento_servicio"
                                    accept=".pdf,.doc,.docx,.jpg,.png,.xls,.xlsx,.csv"
                                    onChange={handleChange}
                                    innerRef={fileInputRef}
                                    style={{ display: 'none' }}
                                />
                            </div>
                        </FormGroup>

                        {/* Campos para el Encargado (Perfil 8) */}
                        {isAdmin && (
                            <>
                                <FormGroup>
                                    <Label>Prioridad:</Label>
                                    <Input
                                        className="form-control"
                                        type="select"
                                        name="prioridad_id"
                                        value={formData.prioridad_id}
                                        onChange={handleChange}
                                    >
                                        <option value="">Seleccione...</option>
                                        {prioridadGestion.map(p => (
                                            <option key={p.tipo_id} value={p.tipo_id}>{p.descripcion}</option>
                                        ))}
                                    </Input>
                                </FormGroup>

                                <FormGroup>
                                    <Label>Horas estimadas:</Label>
                                    <Input
                                        className="form-control"
                                        type="number"
                                        name="horas_estimadas"
                                        value={formData.horas_estimadas}
                                        onChange={handleChange}
                                        placeholder="Ingrese las horas estimadas"
                                        min="0"
                                        step="0.5"
                                    />
                                </FormGroup>

                                <FormGroup>
                                    <Label>Encargado:</Label>
                                    <Input
                                        className="form-control"
                                        type="select"
                                        name="encargado_id"
                                        value={formData.encargado_id}
                                        onChange={handleChange}
                                    >
                                        <option value="">Seleccione...</option>
                                        {usuariosSistemas.map(u => (
                                            <option key={u.usuario_id} value={u.usuario_id}>{u.nombre_completo_usuario}</option>
                                        ))}
                                    </Input>
                                </FormGroup>

                                <FormGroup>
                                    <Label>Fecha Inicio:</Label>
                                    <Input
                                        className="form-control"
                                        type="date"
                                        name="fecha_inicio"
                                        value={formData.fecha_inicio}
                                        onChange={handleChange}
                                    />
                                </FormGroup>

                                <FormGroup>
                                    <Label>Comentario:</Label>
                                    <Input
                                        className="form-control"
                                        type="textarea"
                                        name="comentario"
                                        value={formData.comentario}
                                        onChange={handleChange}
                                        placeholder="Ingrese su comentario."
                                        rows={5}
                                    />
                                </FormGroup>

                                <FormGroup>
                                    <Label>Fecha Entrega:</Label>
                                    <Input
                                        className="form-control"
                                        type="date"
                                        name="fecha_entrega"
                                        value={formData.fecha_entrega}
                                        onChange={handleChange}
                                    />
                                </FormGroup>

                                <FormGroup>
                                    <Label>Estado:</Label>
                                    <Input
                                        className="form-control"
                                        type="select"
                                        name="estado"
                                        value={formData.estado}
                                        onChange={handleChange}
                                    >
                                        {estadosGestion.map(e => (
                                            <option key={e.tipo_id} value={e.tipo_id}>{e.descripcion}</option>
                                        ))}
                                    </Input>
                                </FormGroup>
                            </>
                        )}

                        {/* Non-admins only see Requerimiento + Archivo (no extra details panel) */}

                        {(isNew || isAdmin || (!isAdmin && registro && Number(formData.estado) === 1)) && (
                            <FormGroup>
                                <div className="button-container">
                                    <Button
                                        className="button-custom"
                                        onClick={async () => {
                                            if (window.confirm('¿Está seguro de guardar este registro?')) {
                                                await handleSubmit();
                                            }
                                        }}
                                    >
                                        {registro ? 'ACTUALIZAR' : 'REGISTRAR'}
                                    </Button>
                                </div>
                            </FormGroup>
                        )}

                    </Form>
                </ModalBody>
            </div>
        </Modal >
    );
};

export default ModalGestionServicioSistemas;
